import React from 'react'

const UnavailableIcon = ({ color }: { color: string }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='128'
    height='128'
    viewBox='0 0 128 128'
    fill='none'
    aria-hidden
    className='unavailableIcon'
  >
    <path
      d='M85.1111 50.5254L49.6142 86.0223'
      stroke={color}
      strokeOpacity='0.4'
      strokeWidth='5.89474'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M49.8828 50.5254L65.1692 65.8117'
      stroke={color}
      strokeOpacity='0.4'
      strokeWidth='5.89474'
      strokeMiterlimit='10'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M28.8 13V27.2'
      stroke={color}
      strokeWidth='6'
      strokeLinecap='round'
    />
    <path
      d='M14.4001 27.1992H115.2'
      stroke={color}
      strokeWidth='6'
      strokeLinecap='round'
    />
    <path
      d='M107.2 12.8008H21.6C16.6 12.8008 12.8 18.0008 12.8 24.4008V106.401'
      stroke={color}
      strokeWidth='6'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M107.2 12.8008C111.6 12.8008 115.2 18.0008 115.2 24.6008V71.2008'
      stroke={color}
      strokeWidth='6'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.8 107.199C12.8 111.599 18 115.199 24.6 115.199H71.2001'
      stroke={color}
      strokeWidth='6'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M91.6003 91.9996L114.6 83.5996'
      stroke={color}
      strokeWidth='6'
      strokeLinecap='round'
    />
    <path
      d='M83.8 114.6L91.4 92'
      stroke={color}
      strokeWidth='6'
      strokeLinecap='round'
    />
    <path
      d='M68.2 68.5996L114.6 83.5996'
      stroke={color}
      strokeWidth='6'
      strokeLinecap='round'
    />
    <path
      d='M68.2 68.5996L83.9999 114.6'
      stroke={color}
      strokeWidth='6'
      strokeLinecap='round'
    />
  </svg>
)

export default UnavailableIcon
